import {Injectable, Type} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Injectable({providedIn: 'root'})
export class NewmDialogService {

  constructor(
    private readonly modalService: NgbModal,
  ) {
  }

  public closeDialog(dialogComponent) {
    dialogComponent.closeDialog();
  }

  public openDialog(
    content: Type<unknown>,
    config: NgbModalOptions,
    data?: Record<string, unknown>,
  ): NgbModalRef {
    const modalRef = this.modalService.open(
      content,
      config,
    );


    if (data) {
      for (const key of Object.keys(data)) {
        if (!Object.getOwnPropertyDescriptor(modalRef.componentInstance, key)) {
          console.info(`le champ "${key}" n'existe pas dans le composant "${content.name}"`);
        }
        modalRef.componentInstance[key] = data[key];
      }
    }

    return modalRef;
  }
}
